import { render, staticRenderFns } from "./NewJournalVoucherModal.vue?vue&type=template&id=3b9eb22c&scoped=true"
import script from "./NewJournalVoucherModal.vue?vue&type=script&lang=js"
export * from "./NewJournalVoucherModal.vue?vue&type=script&lang=js"
import style0 from "./NewJournalVoucherModal.vue?vue&type=style&index=0&id=3b9eb22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9eb22c",
  null
  
)

export default component.exports